module.exports = __webpack_public_path__ + "assets/img/5_1146.cef13d34.jpg";